import { Injectable } from '@angular/core';
import * as Immutable from "immutable";
import { ManagedSubject } from "../../../shared/managedSubject";
import { BaseActionCreator } from '../baseActionCreator';
import { BaseEntity } from "../baseEntity";
import { BaseRequest, RequestViews, DefaultRequest, ApiResponse } from "../models";
import { AppStoreSubscriptionManager } from "../providers/appStoreSubscriptionManager";
import { GlobalDataStore } from '../providers/globalData/globalDataStore';
import { ModelFactory } from "../providers/modelFactory";
import { ActionInfo } from "./actionInfo";
import { AppStore } from "./appStore";
import { AppAction } from './shared/appAction';
import { RequestStatus } from './shared/requestStatus';
import { HttpAction } from './shared/httpAction';
import { BaseResponse } from '../models/responses/baseResponse';
import { BaseObject } from '../../../shared';
import { ActionStatus } from './shared/actionStatus';


@Injectable()
export abstract class BaseStore {

  constructor(
    protected appStore: AppStore,
    protected appStoreSubscriptionManager: AppStoreSubscriptionManager,
    protected modelFactory: ModelFactory, // TODO remove model factory     
    protected baseAction: BaseActionCreator
  ) {    

  }
      
  public dispatch<T>(action: AppAction<T>): void {
    this.appStore.dispatch(action);
  }

  protected getActionInfo(actionId: number) {
    return this.appStore.getActionInfo(actionId);
  }

  /** Subscribe to store and return its status (successful/rejected.*/
  protected createAction(action: HttpAction<any>, onfulfilled: (actionInfo: ActionInfo) => void, onrejected?: (actionInfo: ActionInfo) => void): ManagedSubject<any> {
    return this.appStoreSubscriptionManager.createSubject((appStore) => {

      let actionInfo = this.getActionInfo(action.id);
      if (actionInfo && actionInfo.status == RequestStatus.SUCCESS) {
        return onfulfilled(actionInfo);
      }

      if (actionInfo && (actionInfo.status == RequestStatus.ERROR || actionInfo.status == RequestStatus.ABORT)) {
        return onrejected ? onrejected(actionInfo) : ManagedSubject.ErrorValue(actionInfo.payload);
      }

      return ManagedSubject.IGNORE_VALUE;
    }, true);
  }

  getObjectsFromResultId<T extends BaseEntity>(data: Immutable.List<number>): Array<T> {
    let list: T[] = [];

    data.forEach(resultId => {
      list.push(this.getEntity<T>(resultId) as T);
    });

    return list;
  }

  getObjects<T extends BaseEntity>(ids: number[], constructor: { new(): T }): Array<T> {
    let list: T[] = [];

    ids.forEach(id => {
      let entity: T = this.getEntity<T>(id);

      if (entity instanceof constructor)
        list.push(this.getEntity<T>(id) as T);
    });

    return list;
  }

  public getEntity<T extends BaseEntity>(id: number) { return null; }

  public getDefaultData<REQ>(request: REQ, isStoreData?: boolean) : Promise<any> {

    let requestId: number;
    if (isStoreData) {
      requestId = this.appStore.dispatch(this.baseAction.sendDefaultDataAction(request)).id;      
      return this.observeRequestCompletion(requestId).toPromise();
    }

    else {

      return new Promise((resolve, reject) => {

        this.baseAction.baseController.getDefaultData(request)
          .subscribe(result => {

            let action = this.baseAction.sendDefaultDataAction(request);            
            action.executeAsync(null, null, (actionStatus) => {

              resolve(result);

            });
          }, reject);

      });

    }    

  }

  public observeRequestCompletion<R>(requestId: number): ManagedSubject<R> {
    return this.appStoreSubscriptionManager.createSubject<R>((appStore) => {

      let actionInfo: ActionInfo = appStore.getActionInfo(requestId);
      if (actionInfo.status == RequestStatus.SUCCESS) {
        if (actionInfo.payload && actionInfo.payload instanceof ApiResponse) {
          return actionInfo.payload;
        }
      }
      return ManagedSubject.IGNORE_VALUE;
    }, true);
  }

}